import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "app-layout"
};
const _hoisted_2 = {
  class: "app-layout__content"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("footer", {
  class: "app-layout__footer"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "https://beian.miit.gov.cn/",
  target: "_blank",
  rel: "noopener noreferrer"
}, " 沪ICP备2020029998号-2 ")], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_config_provider = _resolveComponent("el-config-provider");
  const _component_a_config_provider = _resolveComponent("a-config-provider");
  return _openBlock(), _createBlock(_component_a_config_provider, {
    locale: _ctx.locale,
    theme: _ctx.themeConfig
  }, {
    default: _withCtx(() => [_createVNode(_component_el_config_provider, {
      locale: _ctx.elzhCN
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("main", _hoisted_2, [_createVNode(_component_router_view)]), _hoisted_3])]),
      _: 1
    }, 8, ["locale"])]),
    _: 1
  }, 8, ["locale", "theme"]);
}